export default () => {

    
    const scrollDrawer = document.querySelector('#steroid-reductions');
    const collapseInactive = document.querySelector('#collapse4');
    const collapseActive = document.querySelector('#collapse3');
    const buttonActive = document.querySelector('[data-target="#collapse3"]');

    if(window.location.href.indexOf("#steroid-reductions") > -1) {

        

        setTimeout(() => {
            collapseInactive.classList.remove("show");
            buttonActive.classList.add("active");

            collapseActive.classList.add("show");
        }, 1200);
          
    }

};
